import { Pipe, PipeTransform } from "@angular/core";
import moment from "moment";
import "moment-timezone";

@Pipe({
  name: "dateTz",
  standalone: false,
})
export class DateTzPipe implements PipeTransform {
  transform(value: any, format = "HH:mm", tz = "UTC"): string {
    if (!value) return "";
    return moment.utc(value).tz(tz).format(format);
  }
}
